import Angular from "angular";
import Controller from "./settings.controller";
import Template from "./settings.html";
import Settings from "../../providers/settings.provider";
import Branches from "../../services/branches.service";

export const SettingsView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.settings', [Settings.name, Branches.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/settings/settings.js